import { Guid } from "@/Common/Models/Guid";

export class PrescriptionRenewalCurrentDocument {
    public documentId: Guid;
    public documentByteId: Guid;

    constructor(fields: Partial<PrescriptionRenewalCurrentDocument>) {
        Object.assign(this, fields);
    }
}
